'use client';

import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';

import {
  CrossLight,
  MagicModalNewContext,
} from 'components/shared/MagicModalNew';
import { useWindowSize } from 'hooks/dom/useWindowSize';
import { CustomImage as Image } from '../shared';
import playIcon from '../../assets/images/play.svg';
import VideoJS from './VideoJS';
import styles from './Vid_old.module.css';

// Memoize video sources and options to prevent recreation
const VIDEO_SOURCES = {
  desktop: {
    src: 'https://cdn.speedsize.com/3f711f28-1488-44dc-b013-5e43284ac4b0/https://public-web-assets.ultrahuman.com/web_v2/hero/hero-section/UH_UltraSignal_R6.mp4',
    type: 'video/mp4',
  },
  mobile: {
    src: 'https://cdn.speedsize.com/3f711f28-1488-44dc-b013-5e43284ac4b0/https://public-web-assets.ultrahuman.com/web_v2/hero/hero-section/UH_UltraSignal_9_16.mp4',
    type: 'video/mp4',
  },
};

const POSTER_IMAGES = {
  desktop:
    'https://cdn.speedsize.com/3f711f28-1488-44dc-b013-5e43284ac4b0/https://public-web-assets.ultrahuman.com/web_v2/hero/hero-categories/desktop/poster.png',
  mobile:
    'https://cdn.speedsize.com/3f711f28-1488-44dc-b013-5e43284ac4b0/https://public-web-assets.ultrahuman.com/web_v2/hero/hero-categories/mobile/poster_new.png',
};

const BASE_VIDEO_OPTIONS = {
  responsive: true,
  enableSmoothSeeking: true,
  breakpoints: {
    tiny: 576,
    xsmall: 768,
    small: 992,
    medium: 1200,
    large: 1400,
    xlarge: 2100,
    huge: 2500,
  },
  fluid: true,
  height: 437,
  controls: true,
  preload: 'auto',
};

const VideoModal = ({ onClose }: { onClose?: () => void }) => {
  const playerRef = useRef(null);
    const videoOptions = useMemo(
      () => ({
        ...BASE_VIDEO_OPTIONS,
        autoplay: true,
        muted: false,
        sources: [VIDEO_SOURCES.desktop],
        poster: POSTER_IMAGES.desktop,
      }),
      [],
    );

    const handlePlayerReady = (player: any) => {
      playerRef.current = player;

      // player.on('waiting', () => {
      //   console.log('Player is waiting');
      // });

      // if (player.ended()) {
      //   console.log('Video has ended');
      // }

      // player.on('dispose', () => {
      //   console.log('Player will dispose');
      // });
    };

    const handlePlay = (player: any) => {
      playerRef.current = player;
      player.on('play', () => {
        const playBtn = document.querySelector('.vjs-big-play-button');
        if (playBtn) {
          (playBtn as HTMLElement).style.display = 'none';
        }
        // const breakpoint = player.currentBreakpoint();
        // console.log(`Current Breakpoint : ${breakpoint}`);

        // console.log('Player is playing');
        // console.log(player.options);
      });
    };

    return (
      <div
        className={styles.videoModal}
        onClick={(e) => e.stopPropagation()}
        aria-hidden="true"
      >
        {onClose ? (
          <div
            className={styles.customBtnContainer}
            onClick={(e) => e.stopPropagation()}
            aria-hidden="true"
          >
            <button onClick={onClose} className={styles.customClose}>
              {CrossLight}
            </button>
          </div>
        ) : null}
        <div className={styles.container}>
          <VideoJS
            options={videoOptions}
            onReady={handlePlayerReady}
            onPlay={handlePlay}
          />
        </div>
      </div>
    );
  };

const OverlayBtn = ({ onClick }: { onClick?: () => void }) => {
  return (
    <div
      className={styles.overlayBtn}
      style={{ '--play-icon': `url(${playIcon.src})` } as React.CSSProperties}
      aria-hidden="true"
      onClick={(e) => {
        e.stopPropagation();
        onClick && onClick();
      }}
    ></div>
  );
};

const Vid = () => {
  const playerRef = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const [openMobModal, setOpenMobModal] = useState(false);
  const MagicModalNewClient = useContext(MagicModalNewContext);
  const { width } = useWindowSize();

  const videoJsOptions = useMemo(
    () => ({
      ...BASE_VIDEO_OPTIONS,
      autoplay: true,
      muted: true,
      loop: true,
      sources: [VIDEO_SOURCES.mobile],
      poster: POSTER_IMAGES.mobile,
    }),
    [],
  );

  const videoJsMobileOptions = useMemo(
    () => ({
      ...BASE_VIDEO_OPTIONS,
      autoplay: true,
      muted: false,
      loop: false,
      sources: [VIDEO_SOURCES.mobile],
      poster: POSTER_IMAGES.mobile,
    }),
    [],
  );

  const handlePlay = (player: any) => {
    playerRef.current = player;
    player.on('play', () => {
      const playBtn = document.querySelector('.vjs-big-play-button');
      if (playBtn) {
        (playBtn as HTMLElement).style.display = 'none';
      }
      const breakpoint = player.currentBreakpoint();
      console.log(`Current Breakpoint : ${breakpoint}`);
      player.requestFullscreen();

      console.log('Player is playing');
      console.log(player.options);
    });
  };

  const handlePlayerReady = (player: any) => {
    playerRef.current = player;

    player.on('waiting', () => {
      console.log('Player is waiting');
    });

    if (player.ended()) {
      console.log('Video has ended');
    }

    player.on('dispose', () => {
      console.log('Player will dispose');
    });
  };

  const openVideoModal = () => {
    MagicModalNewClient.setCloseBtnHidden(true);
    MagicModalNewClient.set(<VideoModal onClose={onCustomCrossClick} />);
    MagicModalNewClient.setCloseBtnHidden(true);
    MagicModalNewClient.show();
  };

  const onCustomCrossClick = () => {
    const closeModal = () => setOpenModal(false);
    MagicModalNewClient.hide(closeModal);
  };

  useEffect(() => {
    if (openModal) {
      if (width > 992) {
        openVideoModal();
      }
    }
  }, [openModal]);

  const onOverlayClick = () => {
    setOpenModal(true);
  };

  const onMobileOverlayClick = () => {
    setOpenMobModal(true);
  };

  return (
    <div className="video-wrapper">
      {width > 992 ? (
        <VideoJS
          options={videoJsOptions}
          onReady={handlePlayerReady}
          onPlay={handlePlay}
        />
      ) : (
        <>
          <div className="image-container">
            <Image
              src={'web_v2/hero/hero-categories/mobile/poster.png'}
              fill
              alt="vid-poster"
            />
          </div>
          {openMobModal ? (
            <div className="mobile-vid">
              <VideoJS
                options={videoJsMobileOptions}
                onReady={handlePlayerReady}
                onPlay={handlePlay}
                closeMobileVid={() => setOpenMobModal(false)}
              />
            </div>
          ) : null}
        </>
      )}
      <OverlayBtn
        onClick={width > 992 ? onOverlayClick : onMobileOverlayClick}
      />
    </div>
  );
};

export default Vid;
